import MediaControlsComponent from '@wix/thunderbolt-elements/src/components/VideoBoxAudio/viewer/VideoBoxAudio';
import MediaControlsController from '@wix/thunderbolt-elements/src/components/VideoBoxAudio/viewer/VideoBoxAudio.controller';


const MediaControls = {
  component: MediaControlsComponent,
  controller: MediaControlsController
};


export const components = {
  ['MediaControls']: MediaControls
};

